




















































import Vue from 'vue';
import * as utenteApi from '../services/utente-api';
import { UtenteListViewModel, UtenteList } from '../types';

export default Vue.extend({
    components: {},
    data(): UtenteListViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.username'),
                    value: 'username',
                },
                {
                    text: this.$i18n.t('labels.nome'),
                    value: 'nome',
                },
                {
                    text: this.$i18n.t('labels.cognome'),
                    value: 'cognome',
                },
                {
                    text: this.$i18n.t('labels.tipo-utente'),
                    value: 'tipoUtente',
                },
                {
                    text: this.$i18n.t('labels.data-ultimo-login'),
                    value: 'dataUltimoLogin',
                },
                {
                    text: this.$i18n.t('labels.password-scaduta'),
                    value: 'passwordScaduta',
                },
                {
                    text: this.$i18n.t('labels.attivo'),
                    value: 'attivo',
                },
            ],
            dataItems: [],
            search: '',
            selectedItems: [],
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await utenteApi.getList();
        },
        showDetail(item: UtenteList) {
            this.$router.push({
                name: 'UtenteDetail',
                params: { id: item.id.toString() },
            });
        },
        async deleteItems(): Promise<void> {
            if (await this.$confirm(this.$t('dialog.default-question').toString(), {
                title: this.$t('dialog.delete-title').toString(),
                color: 'secondary',
                icon: 'mdi-delete',
            })) {
                await utenteApi.remove(this.selectedItems.map(p => {
                    return  {
                        id: p.id, 
                        version: p.version 
                    }
                }));
                await this.loadData();
            }
        },
    },
    async mounted() {
        await this.loadData();
    },
});
